import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Heart({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Heart.Outline {...props} /> : <Heart.Solid {...props} />;
}

Heart.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Heart.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <g>
        <g>
          <path
            id="Path_34179"
            d="M12.1111 22.1576C9.82807 20.7475 7.70577 19.0847 5.78303 17.1998C4.42565 15.854 3.389 14.2107 2.75231 12.3955C1.61467 8.85542 2.93895 4.80967 6.63625 3.60859C8.58776 2.99572 10.7102 3.37194 12.3422 4.62003C13.9748 3.37334 16.0965 2.99724 18.0481 3.60859C21.7454 4.80967 23.0786 8.85542 21.941 12.3955C21.3094 14.2089 20.279 15.8521 18.928 17.1998C17.0035 19.0827 14.8815 20.7452 12.5999 22.1576L12.3511 22.3202L12.1111 22.1576Z"
            className="icon-secondary"
          />
          <path
            id="Path_34178"
            d="M12.3459 22.3202L12.1109 22.1576C9.82509 20.7476 7.69983 19.0849 5.77398 17.1998C4.41016 15.8558 3.36735 14.2124 2.72548 12.3955C1.59674 8.85542 2.92101 4.80967 6.61832 3.60859C8.56982 2.99572 10.7202 3.37223 12.3459 4.63076V22.3202Z"
            className="icon-primary"
          />
          <path
            id="Path_34180"
            d="M18.5654 10.3194C18.3645 10.3065 18.1775 10.2061 18.048 10.0418C17.9186 9.87742 17.8582 9.66359 17.8809 9.45035C17.9026 8.74799 17.503 8.1087 16.8867 7.85996C16.4959 7.75328 16.2592 7.33006 16.357 6.91268C16.4498 6.50201 16.8343 6.24666 17.2208 6.33909C17.2696 6.34719 17.3166 6.36487 17.3593 6.39124C18.595 6.86677 19.3951 8.1466 19.3314 9.54595C19.3294 9.75804 19.2467 9.96017 19.1023 10.106C18.9579 10.2518 18.7641 10.3289 18.5654 10.3194Z"
            className="icon-primary"
          />
        </g>
      </g>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
